import React from 'react';
import { SkeletonFrame } from './styled';

export const SkeletonParagraph: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<SkeletonParagraphProps>>
> = ({ count = 1, circle, height, width, children = <>&zwnj;</>, flex }) => {
  const elements = [];

  for (let i = 0; i < count; i += 1) {
    const elementWidth = count > 1 ? getVariableLength(i) : width;
    const style: React.CSSProperties = {
      height,
      width: elementWidth,
    };

    if (circle) {
      style.borderRadius = '50%';
      if (!width && !height) {
        style.width = '1em';
        style.height = '1em';
      }
    }

    elements.push(
      <React.Fragment key={i}>
        <SkeletonFrame key={i} style={style} flex={flex}>
          {children}
        </SkeletonFrame>
        {count > 1 && <br />}
      </React.Fragment>
    );
  }

  return <>{elements}</>;
};

interface SkeletonParagraphProps {
  count?: number;
  circle?: boolean;
  height?: string | number;
  width?: string | number;
  flex?: boolean;
}

function getVariableLength(i: number) {
  let width = 100;
  width = i % 2 === 0 ? 70 : width;
  width = i % 3 === 0 ? 80 : width;
  width = i % 5 === 0 ? 60 : width;
  width = i === 0 ? 90 : width;

  return `${width}%`;
}
